import BaseController from "./index.controller";

import { BaseControllerEndpoints } from "./index.interfaces";
import { BaseControllerOverviewResposne } from "./index.models";

export { type BaseControllerEndpoints, BaseControllerOverviewResposne };

export default BaseController;
